import { render, staticRenderFns } from "./WorkInProgress.vue?vue&type=template&id=4a65f09b&scoped=true"
import script from "./WorkInProgress.vue?vue&type=script&lang=js"
export * from "./WorkInProgress.vue?vue&type=script&lang=js"
import style0 from "./WorkInProgress.vue?vue&type=style&index=0&id=4a65f09b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a65f09b",
  null
  
)

export default component.exports